"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYER_CLASS_PROFILES = void 0;
exports.PLAYER_CLASS_PROFILES = {
    A: {
        label_i18n: { fr: 'Kiosque navigateur (Mini-PC)', en: 'Browser kiosk (Mini-PC)' },
        default_resolution_px: { w: 1920, h: 1080 },
        default_refresh_hz: 60,
        default_color_profile: 'sRGB',
        audio: 'stereo_optional',
        expected_capability_flags: [
            'can_play_h264',
            'can_play_vp9',
            'can_play_webp',
            'has_audio_out',
            'has_hdmi_out',
            'supports_service_worker',
            'supports_indexeddb_persistent',
        ],
    },
    B: {
        label_i18n: { fr: 'Android TV / STB', en: 'Android TV / STB' },
        default_resolution_px: { w: 1920, h: 1080 },
        default_refresh_hz: 60,
        default_color_profile: 'Rec.709',
        audio: 'stereo_via_hdmi',
        expected_capability_flags: [
            'can_play_h264',
            'can_play_h265',
            'has_audio_out',
            'has_hdmi_out',
            'supports_kiosk_lock',
            'supports_service_worker',
        ],
    },
    C: {
        label_i18n: { fr: 'Contrôleur LED (HDMI amont)', en: 'LED controller (HDMI upstream)' },
        default_resolution_px: { w: 1920, h: 1080 },
        default_refresh_hz: 60,
        default_color_profile: 'sRGB_high_contrast',
        audio: 'none',
        expected_capability_flags: ['can_play_h264', 'can_play_webp', 'has_hdmi_out'],
        advisory: {
            fr: 'Évitez le texte fin et les dégradés photoréalistes; préférez des contrastes élevés.',
            en: 'Avoid fine text and photoreal gradients; prefer high contrast.',
        },
    },
    D: {
        label_i18n: { fr: 'Navigateur sur TV connectée', en: 'Smart TV browser' },
        default_resolution_px: { w: 1920, h: 1080 },
        default_refresh_hz: 60,
        default_color_profile: 'sRGB',
        audio: 'stereo_via_hdmi',
        expected_capability_flags: ['can_play_h264', 'has_audio_out'],
    },
};
//# sourceMappingURL=player-class-profiles.js.map